import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { noop } from 'ui-components/default-props/noop';

const messages = defineMessages({
  title: {
    description: 'Archives Placeholder Title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'O5N6sJ',
  },
  description: {
    description: 'Archives Placeholder Description',
    defaultMessage: 'Error loading Archives, please try again',
    id: 'TyLCb3',
  },
  boldStatusView: {
    description: 'Archives Placeholder Bold Status View Name',
    defaultMessage: 'Archives',
    id: 'Yh2nKz',
  },
});

const ArchiveGridErrorPlaceholder = () => {
  return (
    <ActionablePlaceholder
      action={noop}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};

export default ArchiveGridErrorPlaceholder;
